import { useEffect, useState } from 'react'
import Header from '../../Header'
import * as styled from '../../style/main.style'
import Navbar from '../../Navbar'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import TableCustom from '../../../../component/table/tableCustom'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import { motion } from 'framer-motion'
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../../../component/loading/Loading'
import { FiscalYearApi } from '../../../../api/fiscal-year/fiscalyear.api'
import { StrategyApi } from '../../../../api/strategy/strategy.api'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';


let mockData = [
    {
        id: 1,
        reportName: "รายงานสรุปผลการติดตามและประเมินผลแผนพัฒนาท้องถิ่นในภาพรวม",
        path: '/auth/report/tracking-summary-account/report'
    },
    {
        id: 2,
        reportName: "รายงานสรุปผลการติดตามและประเมินผลแผนพัฒนาท้องถิ่น (แยกตามยุทธศาสตร์/แผนงาน/โครงการ)",
        path: '/auth/report/tracking-summary-account/report-strategy'
    },

]


const TrackingSummary = () => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(2);

    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [strategy, setStrategy] = useState<any[]>([]);

    const headCells = [
        {
            id: "RANK", disablePadding: false,
            width: 100,
            // sortable: true, 
            align: 'center', label: "ลำดับ"
        },
        {
            id: "TOPIC-REPORT",
            disablePadding: false,
            align: "center",
            width: 800,
            // sortable: true,
            label: "รายงาน"
        },
        {
            id: "VIEW",
            disablePadding: false,
            align: "center",
            label: "",
            class: true,
            width: 100
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { id, reportName, path } =
            objData;

        const objRenderData = {
            key: no,
            id: id,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: id },
                {
                    option: "TEXT",
                    align: "left",
                    label: reportName,
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    class: true,
                    component: (
                        <div className='text-left h-full w-full flex justify-end'>
                            <button onClick={() => navigate(path)} className='flex gap-x-3'>
                                <RemoveRedEyeOutlinedIcon className='text-base_disable cursor-pointer' />
                                <Typography>{t("BUTTON.VIEW")}</Typography>
                            </button>
                        </div >
                    ),
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };
    const handleGetFiscalYear = async () => {
        let condition: any = {}
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetStrategy = async () => {
        let condition: any = {}
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        handleGetFiscalYear();
        handleGetStrategy()
    }, [])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <motion.div
                        initial={{ x: 100 }}
                        animate={{ x: 0 }}
                        transition={{ ease: "backInOut", stiffness: 100 }}
                        className='w-full h-auto'>
                        <section>
                            <Typography className='text-primary' variant='h4'>
                                {"รายงานสรุปผลการติดตาม"}
                            </Typography>
                        </section>
                        <section className='w-full mt-3'>
                            <TableCustom
                                tableFixedWidth
                                tableMinWidth={1000}
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={mockData && mockData.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                                hidePagination
                            />
                        </section>
                    </motion.div>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default TrackingSummary
